export default {"src":"/_next/static/media/medal-based-filter-icon.ba57a88b.svg","height":13,"width":17,"blurWidth":0,"blurHeight":0};